module.exports = __webpack_public_path__ + "img/img.eca22435.png";